import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { AnnualAccountFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import * as Yup from "yup";
import { AnnualAccountApproveFormContainerProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import AnnualAccountApproveForm from "./approveForm";
import { useAnnualAccountService } from "serviceHooks";
//#endregion
import { CurrencyHelper, LocalizationHelperInstance } from "utils/helpers";

const AnnualAccountApproveFormContainer: ForwardRefRenderFunction<
  FormHandles,
  AnnualAccountApproveFormContainerProps
> = (props, ref) => {
  const { financialYearId, dividendInformation, enableDividend, isK10OrderMode, onDividendChange } = props;

  const annualAccountService = useAnnualAccountService();

  const maxAmount = Math.floor(dividendInformation?.maxAllowedDividend ?? 0);

  const validationSchema = Yup.object<AnnualAccountFormTypes.Approve>({
    amount: enableDividend && !isK10OrderMode
      ? Yup.number()
          .required(TranslationKeys.Validations.Required)
          .max(
            maxAmount,
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.Max, "", {
              max: CurrencyHelper.toRoundedDownSEK(maxAmount),
            })
          )
      : Yup.number(),
  });

  const initialValues: AnnualAccountFormTypes.Approve = {
    amount: dividendInformation?.nextYearDividend ? dividendInformation.nextYearDividend : undefined,
  };

  const handleSubmit = async (values: AnnualAccountFormTypes.Approve) => {
    return annualAccountService.approveAnnualAccountReport(financialYearId, { amount: values.amount });
  };

  return (
    <AnnualAccountApproveForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={initialValues}
      handleSubmit={handleSubmit}
      enableDividend={enableDividend}
      dividendInformation={dividendInformation}
      financialYearId={financialYearId}
      onDividendChange={onDividendChange}
    />
  );
};

export default forwardRef(AnnualAccountApproveFormContainer);
